import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevealSection } from './components/RevealSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-b from-black via-gray-900 to-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <HookSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <RevealSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <OfferSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <ClosingSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}